import { useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Component to show total time for a specific Work Order + Machine combination
const WorkOrderMachineTimer = ({ workOrderNumber, machineId, machineName }) => {
  const [totalTime, setTotalTime] = useState(0);

  useEffect(() => {
    const fetchAndCalculateTime = async () => {
      try {
        // Fetch all timesheet entries for this work order + machine
        const response = await axios.get(`${API}/timesheet`);
        const entries = response.data;

        // Filter entries for this specific work order + machine combination
        const relevantEntries = entries.filter(
          entry => 
            entry.workorder_number === workOrderNumber && 
            entry.machine_id === machineId
        );

        let totalSeconds = 0;

        relevantEntries.forEach(entry => {
          if (entry.status === "completed" && entry.end_time) {
            // For completed entries, calculate exact time
            const startParts = entry.start_time.split(':');
            const endParts = entry.end_time.split(':');
            const startDate = new Date(entry.date);
            startDate.setHours(parseInt(startParts[0]), parseInt(startParts[1]), 0, 0);
            const endDate = new Date(entry.date);
            endDate.setHours(parseInt(endParts[0]), parseInt(endParts[1]), 0, 0);
            
            const duration = Math.floor((endDate - startDate) / 1000);
            totalSeconds += duration > 0 ? duration : 0;
          } else if (entry.status === "ongoing") {
            // For ongoing entries, calculate time from start to now
            const startParts = entry.start_time.split(':');
            const startDate = new Date(entry.date);
            startDate.setHours(parseInt(startParts[0]), parseInt(startParts[1]), 0, 0);
            const now = new Date();
            
            const duration = Math.floor((now - startDate) / 1000);
            totalSeconds += duration > 0 ? duration : 0;
          }
        });

        setTotalTime(totalSeconds);
      } catch (error) {
        console.error("Error fetching timer data:", error);
      }
    };

    // Fetch immediately
    fetchAndCalculateTime();

    // Update every second for ongoing sessions
    const interval = setInterval(fetchAndCalculateTime, 1000);

    return () => clearInterval(interval);
  }, [workOrderNumber, machineId]);

  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  return (
    <div className="mt-2 p-2 bg-blue-50 border border-blue-200 rounded">
      <p className="text-xs text-blue-600 font-medium">
        Total Time on {machineName}:
      </p>
      <p className="text-lg font-bold text-blue-800 font-mono">
        {formatTime(totalTime)}
      </p>
      <p className="text-xs text-blue-500 mt-1">
        All employees combined for {workOrderNumber}
      </p>
    </div>
  );
};

export default WorkOrderMachineTimer;
